<template>
  <div>
    <div class="sa-mob-header sa-h-sm-up">
      <h5 class="sa-card-tit">Referral Details</h5>

      <button class="sa-btn-back" @click="$emit('close-pop')">
        <i class="icon-arrow-left"></i>
      </button>
    </div>
    <h5 class="sa-card-tit">Referral Details</h5>
    <div class="sa-pt30">
      <div class="sa-row sa-rev-view">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md10 sa-col-lg10">
          <button class="sa-btn-back sa-h-sm-down" @click="$emit('close-pop')">
            <i class="icon-arrow-left"></i>
          </button>
        </div>
        <!-- <div class="sa-col-xs5 sa-col-sm6 sa-col-md2 sa-col-lg2 sa-h-sm-up">
          <div class="sa-form-group selct-btn-sm">
            
            <v-select
              class="sa-slct-sm"
              id="maritalStatus"
              name="Marital Status"
              ><span slot="no-options">No data</span></v-select
            >
          </div>
        </div> -->
        <div class="sa-col-xs5 sa-col-sm6 sa-col-md2 sa-col-lg2">
          <div class="sa-form-group">
            <!-- <label>Today </label> -->
            <v-select class="sa-slct-sm" 
              v-model="status" 
              :items="items"
              :options="items"
              item-text="label"
              item-value="value"
            ></v-select>
          </div>
        </div>
      </div>
      <div>
        <ul class="sa-card-list sa-rev-list" v-if="appList && appList.length">
          <li v-for="(app,i) in appList" :key="i" :class="status.value == 1 ? 'sa-red-card' : ''">
            <i class="sa-date">{{app.date}} - {{app.time}}</i>
            <div class="sa-card-list-box">
              <div class="sa-doct-det">
                <span> Refered to : </span><strong>{{app.referred_to}}</strong>
                <span class="d-block"
                  >{{app.referred_to_subtext}}</span
                >
              </div>
              <div class="sa-doct-apoint">
                <span> Service : </span>{{app.service}}
                <span class="sa-doct-apoint-time">
                  Appointment ID :<span class="sa-text-underline">
                    {{app.parent_apnt_id}}</span
                  >
                </span>
              </div>
            </div>
            <ul class="sa-ref-det-list">
              <li v-if="app.child_apnt_id"
                >Referral Appointment ID :<strong> {{app.child_apnt_id}} </strong></li>
              <li>Patient :<strong> {{app.pname}} </strong></li>
              <li v-if="app.service_date">Service date & Time :<strong> {{app.service_date}} </strong></li >
            </ul>
            <!-- <div>
                <span> Patient : </span><span>{{app.pname}}</span>
            </div> -->
            <div v-if="app.note" class="sa-status">
              <i
                >{{app.note}}</i
              >
            </div>
          </li>
          <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" ref="infiniteLoading"></infinite-loading>
        </ul>
        <div v-else>No Appointments</div>
      </div>
    </div>
    <div class="sa-dialog-white" v-if="loading">
      <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" />
    </div>
  </div>
</template>
<script>
import { oh_url } from "../../../config/endpoints"
import InfiniteLoading from 'vue-infinite-loading';
export default {
  components: {
    "infinite-loading": InfiniteLoading,
  },
  data() {
    return {
      loading: false,
      appList: [],
      metaData: {},
      infiniteId: "",
      page: 1,
      status: { value: 0, label: "Pending" },
      items: [
        { value: 0, label: "Pending" },
        { value: 3, label: "Upcoming" },
        { value: 4, label: "Completed" },
        { value: 1, label: "Failed" },
        { value: 5, label: "Cancelled" }
      ],
    }
  },
  watch: {
    'status.value': {
      immediate: true,
      handler(){
        if(this.status){
          this.appList = []
          this.page = 1
          this.appointmentList()
        }
      }
    }
  },
  mounted() {
    // this.appointmentList()
  },
  methods: {
    infiniteHandler(e) {
      this.appointmentList(e)
    },
    appointmentList(e) {
      let _self = this
      _self.loading = true
       _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/referrals/apt_list`,
          body: {
            page: _self.page,
            limit: 2,
            status: _self.status.value
          }
        })
        .then((response) => {
          if(response && response.status == 1000 && response.data && response.data.data){
            _self.loading = false
            _self.metaData = response.data.metadata[0]
            if(_self.metaData.total_pages == 1 || _self.metaData.page <= _self.metaData.total_pages){
              _self.appList.push.apply(_self.appList, response.data.data)
            }
            if (e) {
              if (_self.metaData.page >= _self.metaData.total_pages) {
                e.complete();
              } else {
                e.loaded();
              }
            }
            _self.page += 1;
          }
        })
    }
  }
}
</script>
<style scoped>
.sa-ref-det-list { margin-top: 20px; padding: 0; display: flex; }.sa-ref-det-list li {    box-shadow: none; margin: 0 7px 0 0; padding: 0 7px 0 0; border-right: 1px solid #000; flex-direction: row; border-radius: 0; }.sa-ref-det-list li:last-child { border-right: none; padding: 0; margin: 0; }
@media only screen and (max-width: 768px), only screen and (max-device-width: 768px) {
.sa-ref-det-list {flex-direction:column;margin-top: 0;}.sa-ref-det-list li { border: none;}
}
</style>